export class ThemeColors {
  constructor(
    public dividersColor: string,
    public primaryTextColor: string,
    public secondaryTextColor: string,
    public primaryColor: string,
    public primaryLighterColor: string,
    public accentColor: string,
    public accentLighterColor: string,
    public warnColor: string,
    public warnLighterColor: string,
    public themeStyleChange: boolean
  ) {}
}
